export default __webpack_public_path__ + "static/media/file-delete.01fe8232.svg";